module.exports = __webpack_public_path__ + "img/austria-tuberculosis-female.48a57142.png";